var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "52", height: "52", viewBox: "0 0 52 52", fill: "none" }, props),
    React.createElement("rect", { width: "52", height: "52", rx: "12", fill: "#07F" }),
    React.createElement("path", { d: "M27.161 34.64c-8.883 0-13.95-6.09-14.161-16.223h4.45c.146 7.438 3.426 10.588 6.025 11.238V18.417h4.19v6.414c2.566-.276 5.261-3.199 6.17-6.414h4.19c-.698 3.962-3.621 6.885-5.7 8.087 2.079.975 5.408 3.524 6.675 8.136h-4.612c-.99-3.085-3.46-5.473-6.723-5.797v5.797h-.504z", fill: "#fff" })
  );
});